var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('MobilePage',[_vm._v("123")]):(_vm.mode == 1)?_c('pageMode1'):(_vm.mode == 2 && _vm.download_model_switch != 1)?_c('pageMode2'):(_vm.mode == 3)?_c('pageMode3'):(_vm.mode == 4)?_c('pageMode4'):(_vm.mode == 2 && _vm.download_model_switch == 1)?_c('pageMode5'):(_vm.mode == 6)?_c('pageMode6'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }